/** @format */

import { checkKeyInObject } from 'utility';
import fieldsBlock from './fieldsInEveryBlocks';

const ErrorHandlingBlocks = (errors, openPanel) => {
  for (const key in fieldsBlock) {
    if (fieldsBlock.hasOwnProperty(key)) {
      const fields = fieldsBlock[key];
      if (checkKeyInObject(errors, fields)) {
        openPanel(key);
        break;
      }
    }
  }
};

export default ErrorHandlingBlocks;
